import { ReactElement, useMemo } from 'react';
import { omit } from 'lodash';

import DialogAddIntegration from '../DialogAddIntegration';

import { DialogRenovateIntegrationProps } from './types';

const DialogRenovateIntegration = ({
  open,
  onClose,
  data,
  onSuccesSubmit,
}: DialogRenovateIntegrationProps): ReactElement => {
  const renovateData = useMemo(() => omit(data, 'integrationTypeId'), [data]);

  return (
    <DialogAddIntegration
      open={open}
      onClose={onClose}
      integrationType={data.integrationTypeId}
      renovateData={renovateData}
      onSuccesSubmit={onSuccesSubmit}
    />
  );
};

export default DialogRenovateIntegration;
